import { map, find, filter } from 'lodash-es';
import i18n from '../../../../i18n';

export default {

  /**
   * Computes a list of units with their translations
   * @param state
   */
  factUnitItems(state) {
    if (!state.facts.units || !state.facts.units.length) {
      return [];
    }
    return map(state.facts.units, u => ({
      id: u.id,
      value: u.value,
      label: i18n.t(`skiFacts.units.${u.value}`),
    }));
  },

  anyFactChecked(state) {
    if (!state.facts.items || !state.facts.items.length) {
      return false;
    }
    return !!find(state.facts.items, { show: true });
  },

  /**
   * Check if the form is valid.
   *
   * @param state
   * @returns {boolean}
   */
  checkFormValid(state) {
    if (!state.facts.items || !state.facts.items.length) {
      return false;
    }
    return !filter(state.facts.items, item => item.show && (item.value === '' || item.unit === '')).length;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/areas/getters.js